// @mui
import { Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
//
import Image from '../../components/Image';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  backgroundColor: theme.palette.secondary.lighter,
  [theme.breakpoints.up('md')]: {
    height: '100%',
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

// ----------------------------------------------------------------------

export default function PracticeWelcome() {
  return (
    <RootStyle>
      <CardContent
        sx={{
          color: 'grey.800',
          p: { md: 0 },
          pl: { md: 5 }
        }}
      >
        <Typography gutterBottom variant="h4">
          Thi Sa Hình,
          <br />XE MÁY, Ô TÔ
          <br />Cập Nhật {new Date().getMonth() + 1}/{new Date().getFullYear()}
        </Typography>

        <Typography variant="body2" sx={{ pb: { xs: 3, xl: 5 }, maxWidth: 480, mx: 'auto' }}>
          Bài thi sa hình xe máy và 11 bài thi sa hình B1, B2 hoặc 10 bài thi sa hình cho hạng C giúp học viên nắm vững kiến thức trước khi thi.
        </Typography>
      </CardContent>

      <Image alt="" src="/illustrations/driving-school.png"
        sx={{
          p: 3,
          height: 260,
          margin: { xs: 'auto', md: 'inherit' },
          width: 260
        }}
      />
    </RootStyle>
  );
}
